import {
	authTokenService
} from '@/services/authTokenService.js';

export const utilityService = {
	getApiUrl: (urlFragment) => __getApiUrl(urlFragment),
	getBaseUrl: (urlFragment) => __getBaseUrl(urlFragment),
	convertStringToNum: (val) => _convertStringToNum(val),
	scrollElemIntoView: (id) => __scrollElementIntoView(id),
	getHeaders: () => __getHeaders(),
	addCurrencyCommas: (val) => __addCurrencyCommas(val),
	getTimeStamp: () => __getTimeStamp(),
	buildFullyQualifiedUrl,
	buildFullyQualifiedIngestUrl,
	buildFullyQualifiedApiAssignUrl,
	buildFullyQualifiedApiGeoUrl,
	buildFullyQualifiedApiAnalysisUrl,
	buildFullyQualifiedIngestUrl,
	encodeQueryStringParameter: (param) => __encodeQueryStringParameter(param)
};

const regex = /,/gi;

function _convertStringToNum(val) {
	if (!val) return 0;

	if (typeof (val) === 'string') return parseInt(val.replace(regex, ''), 10);

	return val;
}

function __scrollElementIntoView(id) {
	if (id) {
		document.getElementById(id).scrollIntoView();
	}
}

/**
 * Appends the url fragment to the api url base.
 * @param {string} urlFragment - A url fragment to append to the api url base.
 */
function __getApiUrl(urlFragment) {
	var hostname = location.hostname;
	var apiUrl = "";
	if (/^.*localhost.*/.test(hostname)) {
		// apiUrl = "https://eagle.westat.com/";
		apiUrl = "https://eagletest.westat.com/";
	  	// apiUrl = "http://localhost:8081/";
		console.log('Hello local');
	} else if (/^.*eagletest.westat.com/.test(hostname)) {
		apiUrl = "https://eagletest.westat.com/";
		console.log('Hello testing');
	} else if (/^.*eagledemo.wesdemo.com/.test(hostname)) {
		apiUrl = "https://eagledemo.wesdemo.com/";
		console.log('Hello staging');
	} else if (/^.*eagle.westat.com/.test(hostname)) {
		apiUrl = "https://eagle.westat.com/";
		console.log('Hello prod');
	} else {
		console.warn(`Cannot find environment for host name ${hostname}`);
	}
	return apiUrl + urlFragment.trim();
}

function __getBaseUrl(urlFragment) {
	return 'https://localhost:8080/' + urlFragment.trim();
}

/**
 * Gets the headers for a web service call. If a token is available it is added to the headers.
 */
function __getHeaders() {
	let headers = {
		'Content-Type': 'application/json',
		'Access-Control-Allow-Origin': '*',
		'Access-Control-Allow-Methods': 'GET,POST,PUT,PATCH,DELETE,HEAD,OPTIONS',
		'Access-Control-Allow-Headers': 'Content-Type, Origin, Accept, Authorization, Content-Length, X-Requested-With, Content-Disposition'
	};
	let token = authTokenService.getToken();

	if (token) {
		headers.Authorization = 'Bearer ' + token;
	}

	return headers;
}

function __addCurrencyCommas(val) {
	return val.replace(/\D/g, '')
		.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}


/**
 * Gets a timestamp in a user readable format. Used for the last saved timestamp.
 */
function __getTimeStamp() {
	let currentDatetime = new Date();
	console.debug(currentDatetime.toString());
	let formattedDate =
		currentDatetime.getFullYear() +
		'-' +
		__appendLeadingZeroes(currentDatetime.getMonth() + 1) +
		'-' +
		__appendLeadingZeroes(currentDatetime.getDate()) +
		' ' +
		__appendLeadingZeroes(currentDatetime.getHours()) +
		':' +
		__appendLeadingZeroes(currentDatetime.getMinutes()) +
		':' +
		__appendLeadingZeroes(currentDatetime.getSeconds());
	return formattedDate;
}

/**
 * Appends leading zeroes to the number if it is a single digit.
 * @param {Number} n - The number to pad.
 */
function __appendLeadingZeroes(n) {
	if (n <= 9) {
		return '0' + n;
	}
	return n;
}

// #region build urls

function buildFullyQualifiedUrl(url) {
	return this.getApiUrl('ui/' + url)
};

function buildFullyQualifiedIngestUrl(url) {
	return this.getApiUrl('ingest/' + url)
};

function buildFullyQualifiedApiAssignUrl(url) {
	return this.getApiUrl('assign/' + url)
};

function buildFullyQualifiedApiGeoUrl(url) {
	return this.getApiUrl('geo/' + url)
};

function buildFullyQualifiedApiAnalysisUrl(url) {
	return this.getApiUrl('analysis/' + url)
};

function __encodeQueryStringParameter(param) {
	if(!param) {
		return param;
	}

	return encodeURIComponent(param)
		.replace(/\-/g, '%2D')
		.replace(/\_/g, '%5F')
		.replace(/\./g, '%2E')
		.replace(/\!/g, '%21')
		.replace(/\~/g, '%7E')
		.replace(/\*/g, '%2A')
		.replace(/\'/g, '%27')
		.replace(/\(/g, '%28')
		.replace(/\)/g, '%29');
}

// #endregion build urls
